module.exports = __webpack_public_path__ + "img/matrix_item.7c4311aa.png";